/**
 * Pure Slack hydrate merge helpers.
 */

import type {
  AttentionItem,
  CurrentUserIdentity,
  SlackMessage,
  SlackThread,
} from '../../domain/types';
import { isMatchingUser } from '../../domain/types';

export function shouldSkipStubHydrate(
  messagesHydrated: boolean | undefined,
  existingMessageCount: number,
): boolean {
  return messagesHydrated === false && existingMessageCount > 1;
}

export function findSlackHydrateTarget(
  items: AttentionItem[],
  itemId: string,
): AttentionItem | undefined {
  const item = items.find((entry) => entry.id === itemId);
  if (!item || item.source !== 'slack') return undefined;
  return item;
}

export function mergeHydratedSlackMessages(
  incoming: SlackMessage[],
  existing: SlackMessage[] | undefined,
  currentUser: CurrentUserIdentity | undefined,
): SlackMessage[] {
  const incomingTs = new Set(incoming.map((message) => message.ts));
  const currentUserId = currentUser?.uid || 'U_CURRENT';
  const extras = (existing || []).filter(
    (message) =>
      !incomingTs.has(message.ts) &&
      (message.user?.id === currentUserId ||
        message.user?.id === 'UJU' ||
        isMatchingUser(message.user, currentUser)),
  );
  return [...incoming, ...extras];
}

export function applyHydratedSlackItem(
  items: AttentionItem[],
  itemId: string,
  mapped: AttentionItem,
  currentUser: CurrentUserIdentity | undefined,
): AttentionItem[] {
  return items.map((entry) => {
    if (entry.id !== itemId) return entry;
    return {
      ...mapped,
      id: itemId,
      messages: mergeHydratedSlackMessages(mapped.messages || [], entry.messages, currentUser),
    };
  });
}

export function upsertRawSlackThread(prev: SlackThread[], thread: SlackThread): SlackThread[] {
  const without = prev.filter(
    (entry) =>
      entry.attentionId !== thread.attentionId && entry.threadTs !== thread.threadTs,
  );
  return [...without, thread];
}
